import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { getToken } from 'resources/api/auth';
import { jwtDecode } from 'jwt-decode';

const PrivateRoute = ({ component, requiredRole = null, groupId = null, access = null, userType = null, ...rest }) => {
  const Comp = component;
  const token = getToken();

  if (!token) {
    return (
      <Route
        {...rest}
        render={({ location }) => (
          <Redirect to={{ pathname: '/login', state: { from: location } }} />
        )}
      />
    );
  }

  // Decodificar userType del JWT una sola vez
  let decodedUserType = null;
  try {
    decodedUserType = jwtDecode(token).userType;
  } catch (error) {
    return (
      <Route
        {...rest}
        render={() => <Redirect to="/login" />}
      />
    );
  }

  // Validar rol requerido (rutas /admin y /empresas)
  if (requiredRole) {
    if (decodedUserType !== requiredRole) {
      // Redirigir al panel correcto según el tipo de usuario
      const fallback =
        decodedUserType === 'admin'    ? '/admin'    :
        decodedUserType === 'business' ? '/empresas' : '/home';
      return (
        <Route
          {...rest}
          render={() => <Redirect to={fallback} />}
        />
      );
    }
  } else {
    // Rutas sin requiredRole son solo para client y therapist
    // Admin y Business tienen sus propios paneles — no deben acceder a /home
    if (decodedUserType === 'admin') {
      return (
        <Route
          {...rest}
          render={() => <Redirect to="/admin" />}
        />
      );
    }
    if (decodedUserType === 'business') {
      return (
        <Route
          {...rest}
          render={() => <Redirect to="/empresas" />}
        />
      );
    }
  }

  return (
    <Route
      {...rest}
      render={({ location }) => <Comp {...rest} location={location} />}
    />
  );
};

export default PrivateRoute;
